import React, { memo, useEffect, useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import CustomerPhoneField from 'forms/fields/PhoneField/CustomerPhoneField';
import BirthdayField from 'forms/fields/BirthdayField';
import EmailField from 'forms/fields/EmailField';
import SkypeField from 'forms/fields/SkypeField';
import FirstNameField from 'forms/fields/FirstNameField';
import LastNameField from 'forms/fields/LastNameField';

const { el } = bem('order-form', 'form');
const UserInfo = (props) => {
    const { workingOffline, customerPhone, isAuthenticated, username, setPhone, setCustomerFound, setUsername = () => {} } = props;
    const [ { isPhoneValid, customerName }, setCustomerInfo ] = useState({ isPhoneValid: false, customerName: null });

    useEffect(() => {
        if (isAuthenticated && username) {
            setPhone(username);
        }
    }, [ isAuthenticated, username ]);

    useEffect(() => {
        setCustomerFound(!!customerName);
        if (isPhoneValid) {
            setUsername(customerPhone);
        }
    }, [ customerName, isPhoneValid ]);

    return (
        <div className={ el('user-fields-block') }>
            <div className={ el('content-block') }>
                <div className={ el('user-fields-header') }>
                    <Text serif>Ваши данные</Text>
                </div>
                <div className={ el('user-fields') }>
                    <div className={ el('user-fields-first-row') }>
                        <CustomerPhoneField name={ 'customerPhone' } setCustomerInfo={ setCustomerInfo }
                                            disabled={ isAuthenticated }/>
                        { isPhoneValid && !customerName && <>
                            <BirthdayField/>
                            <EmailField/>
                        </> }
                    </div>
                    <div className={ el('user-fields-second-row') }>
                        { isPhoneValid && !customerName && <>
                            { !workingOffline && <SkypeField/> }
                            <FirstNameField/>
                            <LastNameField/>
                        </> }
                    </div>
                </div>
                { isPhoneValid && !customerName && <div className={ el('user-fields-text') }>
                    <Text>На основе предоставленных данных будет создан личный кабинет</Text>
                </div> }
            </div>
        </div>
    );
};

export default memo(UserInfo);
